<script>
    // Подсказки клавиш — дизайн Living City: золотые чипы. Положение задаётся
    // в редакторе худа (блок «hints»), по умолчанию справа по центру.
    // Показывает РЕАЛЬНЫЕ бинды из store/keys (клиент шлёт keysStore.updateName
    // позиционным индексом массива global.userBinder из src_client/player/bind.js).
    import { charIsPet } from 'store/chars'
    import { isHelp, inVehicle } from 'store/hud'
    import keys from 'store/keys'
    import keysName from 'json/keys.js'
    import { hudEditMode } from 'store/hudlayout'
    import HudBox from './hudbox.svelte'

    let isHint = false
    window.hudStore.isHint = (value) => isHint = value

    let HideHelp = false
    window.hudStore.HideHelp = (value) => HideHelp = value

    // [индекс в userBinder, подпись, показывать только в ТС]
    const HINTS = [
        [12, 'Инвентарь', false],
        [64, 'Главное меню', false],
        [8,  'Анимации', false],
        [30, 'Телефон', false],
        [62, 'Планшет', false],
        [36, 'Микрофон', false],
        [38, 'Двигатель', true],
        [39, 'Замок ТС', true],
        [27, 'Скрыть HUD', false],
    ];

    // store/keys по умолчанию = 85 ('U') для всех — реальные значения присылает
    // клиент при загрузке биндов; в браузерном превью подставляет _hud.html.
    const keyLabel = (code) => {
        const n = keysName[code];
        if (!n || n === 'Нет') return '—';
        return n;
    };
</script>

{#if (!$charIsPet && $isHelp && !HideHelp) || $hudEditMode}
    <HudBox id="hints" label="подсказки клавиш">
        <div class="jrh-hints">
            {#each HINTS as h (h[0])}
                {#if !h[2] || $inVehicle || $hudEditMode}
                    <div class="jrh-hint">
                        <b>{keyLabel($keys[h[0]])}</b>
                        <p>{h[1]}</p>
                    </div>
                {/if}
            {/each}
        </div>
    </HudBox>
{/if}

<style>
    .jrh-hints {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5vh;
        font-family: 'Manrope', 'Gilroy', sans-serif;
    }

    .jrh-hint {
        display: flex;
        align-items: center;
        gap: 0.8vh;
    }

    /* клавиша — золотой чип Living City */
    .jrh-hint b {
        min-width: 3.2vh;
        height: 2.6vh;
        padding: 0 0.7vh;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.8vh;
        background: linear-gradient(135deg, #f0c863, #c8852f);
        border: 1px solid rgba(231, 174, 63, 0.6);
        box-shadow: 0 0.4vh 1.1vh rgba(0, 0, 0, 0.4);
        color: #241a06;
        font-size: 1.1vh;
        font-weight: 900;
        letter-spacing: 0.04em;
        white-space: nowrap;
    }

    /* подпись справа */
    .jrh-hint p {
        margin: 0;
        padding: 0.35vh 0.9vh;
        border-radius: 0.7vh;
        background: rgba(16, 13, 10, 0.72);
        border: 1px solid rgba(255, 255, 255, 0.08);
        font-size: 1.15vh;
        font-weight: 700;
        color: rgba(243, 234, 214, 0.88);
        text-shadow: 0 1px 6px rgba(0, 0, 0, 0.7);
        white-space: nowrap;
    }
</style>
